<div class="application-container">
  <router-outlet></router-outlet>
  <app-debugger-panel *ngIf="showDebugger"></app-debugger-panel>
</div>
